import React, { useEffect, useState } from "react";
import {
    Delete as DeleteIcon,
    Edit as EditIcon,
    Add as AddIcon,
} from "@material-ui/icons";
import DataTable from "../../../components/data-table";
import FormModalContent from "./form";
import ConfirmModalContent from "../../../components/confirm-modal-content";
import { useMemo } from "react";
import colorsService from "../../../services/colors.service";
import PaletteIcon from "@material-ui/icons/Palette";
import SelectCategoryModal from "./SelectCategoryModal";
import { useErrorHandler } from "../../../hooks";

const defaultKeys = [
    {
        title: "نام",
        field: "name",
        active: true,
    },
];

export default function ColorsPage() {

    const errorHandler = useErrorHandler();

    const [data, setData] = useState([]);
    const deleteItem = async (item) => {
        const res = await colorsService.deleteColor(item.id);
        if(res.error){
            const error = res.error.response.data.error;
            errorHandler(error);
        }
    };

    const headerCells = useMemo(
        () => [
            {
                field: "name",
                title: "نام",
                mainField: true,
            },
            {
                field: "categoryName",
                title: "دسته بندی",
                mainField: true,
            },
            {
                field: "color",
                title: "کد رنگ",
                renderer: (val) =>
                    val ? (
                        <div className="d-flex align-center">
                            <span className="color-circle" style={{ backgroundColor: val }} />
                            <span className="en ms-1">{val}</span>
                        </div>
                    ) : (
                        "-"
                    ),
            },
            {
                field: "imageUrl",
                title: "تصویر رنگ",
                renderer: (val) =>
                    val ? <img className="color-circle" src={val} alt="" /> : "-",
            },
        ],
        []
    );

    useEffect(() => {
        onRefresh();
    }, []);

    const onRefresh = async () => {
        const { data, error } = await colorsService.getColors();
        if (error) {
            // handleError(error);
            return;
        }

        setData(data.map(item => ({
            ...item,
            categoryName: item?.categories?.map(item => item.name).join(" | ")
        })));
    };
    return (
        <div className="p-3">
            <DataTable
                headCells={headerCells}
                data={data}
                onRefresh={onRefresh}
                rowActions={[
                    {
                        modalProps: { maxWidth: "sm" },
                        icon: <PaletteIcon />,
                        modalContent: (props) => <SelectCategoryModal {...props} />,
                    },
                    {
                        modalProps: { maxWidth: "sm" },
                        icon: <EditIcon />,
                        modalContent: (props) => <FormModalContent {...props} />,
                    },
                    {
                        modalProps: { maxWidth: "sm" },
                        icon: <DeleteIcon />,
                        modalContent: (props) => (
                            <ConfirmModalContent
                                onConfirm={() => deleteItem(props.data)}
                                confirmText={props.data.name}
                                close={props.close}
                            />
                        ),
                    },
                ]}
                actions={[
                    {
                        modalProps: { maxWidth: "sm" },
                        icon: <AddIcon />,
                        tooltip: "ایجاد رنگ",
                        modalContent: (props) => <FormModalContent {...props} />,
                    },
                ]}
                searchKeys={defaultKeys}
                title="رنگ‌ها"
            />
        </div>
    );
}
